<template>
  <div
    class="flex flex-col space-y-4 items-center border-b border-solid pb-5 mb-4 sm:mb-0 sm:border-none sm:space-x-20 sm:space-y-0 sm:h-16 sm:flex-row sm:justify-end sm:items-center"
  >
    <div
      v-for="link in links"
      :key="link.to"
      :id="`link-${link.to}`"
      class="text-fg-link-primary font-sans cursor-pointer link"
      :class="activeLinkClasses(link.matchRoutes)"
      @click="goTo(link.to)"
    >
      {{ link.text }}
    </div>
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue'

interface Link {
  to: string
  text: string
  matchRoutes: string[]
}

export default defineComponent({
  name: 'SubLinks',
  props: {
    links: {
      type: Array as PropType<Link[]>,
      required: false,
      default: () => [
        {
          text: 'Shows',
          to: 'showList',
          matchRoutes: ['/shows', '/performance'],
        },
        {
          text: 'Show Times',
          to: 'showtimes',
          matchRoutes: ['/showtimes'],
        },
        {
          text: 'Floor Plans',
          to: 'floorPlans',
          matchRoutes: ['/floorplans'],
        },
      ],
    },
  },
  methods: {
    async goTo(nameRoute: string) {
      await this.$router.push({ name: nameRoute })
    },
    activeLinkClasses(matchWords: string[]) {
      return {
        'font-semibold text-black': matchWords.some(word => this.$route.path.includes(word)),
      }
    },
  },
})
</script>
